import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { Observable, Subject, throwError } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { AlertService, MessageSeverity } from './alert.service';
import { ConfigurationService } from './configuration.service';

@Injectable({
  providedIn: 'root'
})

export class ErrorHandleService {
  private readonly sessionExpired = 'セッションが切断されました。';

  private taskPauser: Subject<any>;

  private isRefreshingLogin: boolean;

  constructor(private router: Router, private authService: AuthService,
    private alertService: AlertService, private configurations: ConfigurationService, ) { }

  private redirectBySessionTimeout(detail: string) {
    this.alertService.showMessage("セッションタイムアウト", detail, MessageSeverity.warn);

    this.router.navigate(['/login']);
  }

  private pauseTask(continuation: () => Observable<any>) {
    if (!this.taskPauser)
      this.taskPauser = new Subject();

    return this.taskPauser.pipe(switchMap(continueOp => {

      if (continueOp)
        return continuation();

      this.redirectBySessionTimeout(this.sessionExpired);
    }));
  }

  private resumeTasks(continueOp: boolean) {
    setTimeout(() => {
      if (this.taskPauser) {
        this.taskPauser.next(continueOp);
        this.taskPauser.complete();
        this.taskPauser = null;
      }
    });
  }

  showMessageAndRedirect(summary: string, detail: string, error?: any) {
    this.alertService.showStickyMessage(summary, detail, MessageSeverity.error, error);

    this.router.navigate(['/error']);
  }

  handleError(error, continuation: () => Observable<any>) {

    if (error.status == 401) {
      if (this.isRefreshingLogin) {
        return this.pauseTask(continuation);
      }

      this.isRefreshingLogin = true;

      return this.authService.refreshLogin().pipe(
        mergeMap(data => {
          this.isRefreshingLogin = false;
          this.resumeTasks(true);

          return continuation();
        }),
        catchError(refreshLoginError => {
          this.isRefreshingLogin = false;
          this.resumeTasks(false);

          if (refreshLoginError.status == 401 ||
            (refreshLoginError.url && refreshLoginError.url.toLowerCase().includes(this.configurations.tokenUrl.toLowerCase()))) {

            this.authService.reLogin();
          }

          this.redirectBySessionTimeout(this.sessionExpired);
          return refreshLoginError;
        }));
    }

    if (error.url && error.url.toLowerCase().includes(this.configurations.tokenUrl.toLowerCase())) {
      this.authService.reLogin();

      const detail = (error.error && error.error.error_description)
        ? `${this.sessionExpired} (${error.error.error_description})`
        : this.sessionExpired;

      this.redirectBySessionTimeout(detail);

      return;
    }
    else {
      return throwError(error);
    }
  }
}
